import { render, staticRenderFns } from "./LoginWithSSO.vue?vue&type=template&id=51b52d9e&scoped=true&"
import script from "./LoginWithSSO.vue?vue&type=script&lang=js&"
export * from "./LoginWithSSO.vue?vue&type=script&lang=js&"
import style0 from "./LoginWithSSO.vue?vue&type=style&index=0&id=51b52d9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b52d9e",
  null
  
)

export default component.exports